export * from "./product"

export const permanentFormIds = {
  MULTI_MODIF: "multiModif",
  NEW_PRODUCT: "newProduct",
}

export interface ITranslations {
  mails: { [key: string]: string }
  toastrLabels: { [key: string]: string }
  productList: { [key: string]: string }
  productForm: { [key: string]: string }
  multiModif: { [key: string]: string }
  home: { [key: string]: string }
  header: { [key: string]: string }
  global: { [key: string]: string }
  sideBar: { [key: string]: string }
  fieldErrors: { [key: string]: string }
}

export interface ISupplierInfo {
  supplierName: string
  eanMandatory: boolean
}

export interface IHandleChangeProps {
  code: string
  fieldValue?: any
  lock: LockStatus
  fieldType: FieldType
  overrideDefaultValue?: boolean
  forceAcceptEmptyArray?: boolean
  allowDefaultValue?: boolean
}

export interface IFileDetails {
  blob: string | ArrayBuffer | null
  path: string
  file: File
  isMain: boolean
  name: string
  isNew: boolean
  isRestored?: boolean
}

export enum FieldType {
  Standard = "standard",
  Tech = "tech",
}

export interface IBusinessUnitResult {
  supplierBusinessUnit: string
  marketLeaderBusinessUnit: string
}

export type LockStatus = "lock" | "unlock"
